import React from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Alert,
  Button,
  Divider,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import LogDiveForm from "../dives/LogDiveForm";

const DiveFormSection = ({
  loading,
  error,
  validToken,
  diveData,
  claimCompleted,
  onDiveSubmitted,
}) => {
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 4,
          height: "100%",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 4 }}>
        <Alert severity="error">
          {error || "There was an error processing this claim."}
        </Alert>
      </Box>
    );
  }

  if (!validToken) {
    return (
      <Box sx={{ p: 4 }}>
        <Alert severity="warning">
          This claim link is invalid or has expired.
        </Alert>
      </Box>
    );
  }

  if (claimCompleted) {
    return (
      <Box sx={{ p: 4 }}>
        <Alert severity="success" sx={{ mb: 2 }}>
          Dive recorded successfully!
        </Alert>

        <Box sx={{ mt: 4, p: 3, bgcolor: "background.paper", borderRadius: 1 }}>
          <Typography variant="h5" gutterBottom>
            Thanks for logging your dive!
          </Typography>

          <Typography variant="body1" paragraph>
            Your dive at has been successfully added to the community logbook.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body1" paragraph>
            Ready for your next adventure?
          </Typography>

          <Button
            component={RouterLink}
            to="/sites"
            variant="contained"
            color="primary"
            sx={{ mt: 1 }}
          >
            Explore Dive Sites
          </Button>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>
        Complete Your Dive Log
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        This shared dive was created by a buddy. Complete the form to add it to
        your logbook.
      </Typography>

      {diveData && (
        <LogDiveForm
          divesiteid={diveData.divesite}
          preFillData={diveData}
          onSubmitSuccess={onDiveSubmitted}
          isClaimMode={true}
        />
      )}
    </Box>
  );
};

export default DiveFormSection;
